"use client";

import type { TennisTemplateData } from "../tennis-template";
import { ActivityCourtPreview } from "./activity-court-preview";

type TennisDisplayPreviewProps = {
  data: TennisTemplateData | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function TennisDisplayPreview({
  data,
  participants,
}: TennisDisplayPreviewProps) {
  const yourTeam = participants
    .filter((p) => data?.positions?.[p.id] === "your-team")
    .map((p) => ({ ...p, handle: p.username ?? undefined }));
  const opponentTeam = participants
    .filter((p) => data?.positions?.[p.id] === "opponent-team")
    .map((p) => ({ ...p, handle: p.username ?? undefined }));

  const showScore = data?.hasScore !== false;
  const yourSets = data?.matchScore?.yourSets ?? 0;
  const opponentSets = data?.matchScore?.opponentSets ?? 0;
  const yourWon = yourSets > opponentSets;

  return (
    <div>
      <ActivityCourtPreview
        activityId="tennis"
        mode={data?.mode ?? "singles"}
        yourTeam={yourTeam}
        opponentTeam={opponentTeam}
        yourWon={showScore ? yourWon : undefined}
        showLabels={false}
        linkToProfiles
        tennisMatchScore={
          showScore && data?.matchScore ? data.matchScore : undefined
        }
        tennisSets={showScore && data?.sets ? data.sets : undefined}
      />
    </div>
  );
}
